import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DiscordService {

  savedTracks: any = [];

  constructor() { }

  setTracks(track:any){
    this.savedTracks.unshift(track);  
  }

  getTracks(){
    return this.savedTracks;
  }
}
